import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import localforage from 'localforage';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  levelsMinimumVolumeState
} from '#state';

export function LevelsMinimumVolume() {
  const [volume, setVolume] = useRecoilState(levelsMinimumVolumeState);

  useEffect(() => {
    localforage.setItem('levelsMinimumVolume', volume);
  }, [volume]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    const v = parseFloat(newValue)
    if (v >= 1) {
      setVolume(v);
    } else {
      setVolume(1);
    }
  };

  return (
    <TextField
      sx={{
        width: '6rem',
        background: 'linear-gradient(rgba(218, 108, 7, 0.3) 0% 45%, rgba(7, 117, 218, 0.3) 55% 100%)'
      }}
      label="Futures > $k"
      type="number"
      size='small'
      inputProps={{ min: 1 }} // set the minimum value to 1
      value={volume}
      onChange={handleChange}
    />
  );
}

export default LevelsMinimumVolume;